// extracted by mini-css-extract-plugin
module.exports = {"root":"PendingPaymentAlert_root__2b3D6","buttons":"PendingPaymentAlert_buttons__3QhmH"};